<template>
    <div class="dashboard__list_enrolments_table">
        <component-table
            :labels="tableLabels"
            :items="items"
            :empty-state-title="emptyStateTitle"
            :empty-state-content="emptyStateContent"
            :empty-state-button-active="emptyStateButtonActive"
            :empty-state-button-text="emptyStateButtonText"
            :component-table-item="DashboardListEnrolmentsTableItem"
            :component-table-collapse-item="DashboardListEnrolmentsTableItemCollapseTable"
            :component-table-collapse-item-active="activeCollapseIndex"
            :name="name"
            :sort-queryable="sortQueryable"
            @emit-sort="handleSort"
            @emit-empty-state-submit="redirectToCatalogue"
        />
        <a class="dashboard__list_enrolments_table_icsfile hidden" id="download-ics-file"></a>
    </div>
</template>

<script>
import DashboardListEnrolmentsTableItem from '@/components/dashboard/list/enrolments/DashboardListEnrolmentsTableItem'
import DashboardListEnrolmentsTableItemCollapseTable from '@/components/dashboard/list/enrolments/DashboardListEnrolmentsTableItemCollapseTable'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  name: 'dashboard-list-enrolments-table',
  components: { ComponentTable },
  data () {
    return {
      activeCollapseIndex: '',
      DashboardListEnrolmentsTableItem,
      DashboardListEnrolmentsTableItemCollapseTable
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    },
    emptyStateTitle: {
      type: String
    },
    emptyStateContent: {
      type: String
    },
    emptyStateButtonActive: {
      type: Boolean
    },
    emptyStateButtonText: {
      type: String
    },
    name: {
      type: String
    },
    componentTableName: {
      type: String
    }
  },
  computed: {
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    tableLabels () {
      let labels = []

      labels.push({
        key: 'courseName',
        title: 'Name',
        type: 'string'
      })
      if (!this.loggedInUserWorkspaceId) {
        labels.push({
          key: 'workspaceName',
          title: 'Workspace',
          type: 'string',
          sortable: true,
          queryable: true
        })
      }
      labels.push({
        key: 'enrolmentDateTime',
        title: 'Enrolment date',
        type: 'date',
        sortable: true,
        queryable: true
      })
      if (this.name === 'dashboard-list-completions-courses' || this.name === 'lms-superadmin-users-profile-edit-learning-history-courses') {
        labels.push({
          key: 'completedAt',
          title: 'Completion date',
          type: 'date',
          sortable: true,
          queryable: true
        })
      }
      labels.push({
        key: 'enrolmentStatus',
        title: 'Status',
        type: 'string',
        sortable: true,
        queryable: true
      })
      if (this.name !== 'dashboard-list-completions-courses') {
        labels.push({
          key: 'progress',
          title: 'Progress',
          type: 'string',
          sortable: true,
          queryable: true
        })
      }
      labels.push({
        key: 'actions',
        title: '',
        type: '',
        sortable: false
      })

      return labels
    }
  },
  methods: {
    handleCollapse (value) {
      this.activeCollapseIndex = this.activeCollapseIndex !== value ? value : ''
    },
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    redirectToCatalogue () {
      this.$router.push({ name: 'ebs-course-list', query: { view: 'learner' } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlisttable.scss";
</style>
